import React from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";

import TeamLogo from "../../_partials/TeamLogo";
import { PresetColors } from "../../../../shared/components/MediaLibrary/EditModal/LeftSidebar/EditTab";

// Everything this template paints on top of its background layers.
//
// The editor canvas draws those layers itself as draggable boxes, so it renders
// this overlay alone (see EditModal/slider3Content.js) while the template's
// Index.jsx renders it over its own static copy of them. Both get the same
// markup from here, which is what stops the preview and the exported image
// drifting apart.
const SliderOverlay = ({ data, jersey }) => {
  const { t } = useTranslation();

  const { last10Matches } = data?.data?.dynamic || {};
  const selectedLang = data?.lang;
  const competitionId = data?.event?.competitionId;

  return (
    <div className="match-results-container">
      <div className="match-results-left-container">
        {
          last10Matches?.slice(0, 5).map((item) => {
            const { matchInfo, liveData: { matchDetails } } = item;
            const _homeTeam = matchInfo?.contestant?.[0];
            const _awayTeam = matchInfo?.contestant?.[1];
            const score = matchDetails?.scores?.total;
            let homeScore = score?.home ?? 0;
            let awayScore = score?.away ?? 0;
            const date = matchInfo?.date?.replace('Z', '');
            return (
              <div className="result-item">
                <div className="home-team-logo-container">
                  <TeamLogo team={_homeTeam} competitionId={competitionId} />
                </div>
                <div className="item-score-container">
                  <div className="item-score-date">
                    {date}
                  </div>
                  <div className="item-score-value">
                    {homeScore} - {awayScore}
                  </div>
                </div>
                <div className="away-team-logo-container">
                  <TeamLogo team={_awayTeam} competitionId={competitionId} />
                </div>
              </div>
            )
          })
        }
      </div>

      <div className="match-results-right-container">
        {
          last10Matches?.slice(5).map((item) => {
            if (!item) return <></>;
            const { matchInfo, liveData: { matchDetails } } = item;
            const _homeTeam = matchInfo?.contestant?.[0];
            const _awayTeam = matchInfo?.contestant?.[1];
            const score = matchDetails?.scores?.total;
            let homeScore = score?.home ?? 0;
            let awayScore = score?.away ?? 0;
            const date = matchInfo?.date?.replace('Z', '');
            return (
              <div className="result-item">
                <div className="home-team-logo-container">
                  <TeamLogo team={_homeTeam} competitionId={competitionId} />
                </div>
                <div className="item-score-container">
                  <div className="item-score-date">
                    {date}
                  </div>
                  <div className="item-score-value">
                    {homeScore} - {awayScore}
                  </div>
                </div>
                <div className="away-team-logo-container">
                  <TeamLogo team={_awayTeam} competitionId={competitionId} />
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  );
};

// The side fades sit outside `.wc-content`, a level up from the overlay, so
// they are their own export rather than part of the fragment above.
export const SliderGradients = () => (
  <>
    <div className="gradient-left"></div>
    <div className="gradient-right"></div>
  </>
);

export default SliderOverlay;
